import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import NutriLab from "@/pages/NutriLab";
import AdminLogin from "@/pages/AdminLogin";
import PatientPortal from "@/pages/PatientPortal";
import * as api from "@/lib/api";

function RequireAuth({ children }) {
  const [state, setState] = useState("checking");
  useEffect(() => { api.authMe().then(() => setState("ok")).catch(() => setState("no")); }, []);
  if (state === "checking") {
    return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="auth-checking"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  }
  return state === "ok" ? children : <Navigate to="/admin-login" replace />;
}

function RequirePrivate({ children }) {
  const [state, setState] = useState("checking");
  useEffect(() => { api.authMe().then((m) => setState(m.private ? "ok" : "no")).catch(() => setState("no")); }, []);
  if (state === "checking") {
    return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="private-checking"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  }
  return state === "ok" ? children : <Navigate to="/?unlock=1" replace />;
}

function Workspace({ ws, children }) {
  api.setWorkspace(ws);
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/paziente" element={<PatientPortal />} />
          <Route path="/privato" element={<RequireAuth><RequirePrivate><Workspace ws="private"><NutriLab key="private" workspace="private" /></Workspace></RequirePrivate></RequireAuth>} />
          <Route path="*" element={<RequireAuth><Workspace ws="main"><NutriLab key="main" workspace="main" /></Workspace></RequireAuth>} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" theme="dark" />
    </div>
  );
}

export default App;
